module.exports = __webpack_public_path__ + "static/media/sidenav-icon-sales.3ec620dd.svg";